/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Типы контента, на который распространяются жанры<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Book</b>: Книга</li>\n<li><b>4 - Album</b>: Альбом</li>\n<li><b>5 - Mood</b>: Настроение</li>\n</ul>\n
 */
export const tagContentTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]).describe("Типы контента, на который распространяются жанры<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Book</b>: Книга</li>\n<li><b>4 - Album</b>: Альбом</li>\n<li><b>5 - Mood</b>: Настроение</li>\n</ul>\n")